/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function ExperienceIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-experience">
        <g id="Group 68 Copy 2">
          <g id="Group 66 Copy 2">
            <g id="Group 65 Copy 2">
              <g id="Group 63 Copy 2">
                <g id="Group 61 Copy 2">
                  <g id="Group 59 Copy 3">
                    <g id="icon-legal and finance copy">
                      <g id="Group 58 Copy 2">
                        <g id="icon-journey-course">
                          <circle
                            id="Oval"
                            cx="78.5"
                            cy="78.5"
                            r="77.5"
                            fill={mainColor}
                            stroke="white"
                            stroke-width="2"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="briefcase copy">
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M95.7917 51.8001H113.083C116.898 51.8001 120 55.0292 120 59V69.8C120 73.771 116.898 77 113.084 77H85.4169V75.2C85.4169 74.205 84.6435 73.3999 83.6877 73.3999H73.3127C72.3569 73.3999 71.5834 74.205 71.5834 75.2V77H43.9167C40.102 77 37 73.771 37 69.8V59C37 55.0292 40.102 51.8001 43.9167 51.8H61.2083V48.2C61.2083 44.229 64.3104 41 68.125 41H88.875C92.6898 41 95.7917 44.2292 95.7917 48.2V51.8001ZM68.125 51.8001H88.875V48.2H68.125V51.8001Z"
            fill={secondaryColor}
          />
          <path
            id="Path"
            d="M119.041 77.1887C118.451 76.8868 117.747 76.9567 117.227 77.365C115.998 78.3266 114.566 78.8344 113.083 78.8344H85.4166V84.1953C85.4166 85.183 84.6432 85.9823 83.6874 85.9823H73.3124C72.3566 85.9823 71.5832 85.183 71.5832 84.1953V78.8344H43.9167C42.4341 78.8344 41.0021 78.3266 39.7727 77.365C39.2509 76.9532 38.5485 76.8833 37.959 77.1887C37.3716 77.4908 37 78.1101 37 78.7891V103.852C37 107.794 40.102 111 43.9167 111H113.083C116.898 111 120 107.794 120 103.852V78.7891C120 78.1101 119.628 77.4908 119.041 77.1887Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

ExperienceIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
ExperienceIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(ExperienceIcon);
memoized.displayName = 'ExperienceIcon';
export default memoized;
